export const CANNOT_GUARANTEE_TURNAROUND_TIME =
  'At this moment, we cannot guarantee turnaround times due to COVID-19 and the stress being placed on the supply chains. We estimate new orders will be ready to ship within 4 weeks. Thank you for your patience!';
